// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";

// Import Styles
import '../assets/styles/containerStyles/dashboard.scss';

// Import components
import InfiniteScroll from "react-infinite-scroller";
import PageWrapper from '../components/pageContentViews/pageWrapper';
import PageHeader from "../components/pageContentViews/pageHeader";
import BlogCard from "../components/cards/BlogCard";

// Import utils
import {mapStateToProps} from "../redux/mapStateToProps";
import {GetBlogs, setPageOffset} from "../redux/actions";
import {ACCESS_PAGES} from "../constants/accessPages";
import {InputGroup} from "../components/uiElements/inputGroup";
import { defaultEmptyView } from "../assets/images";
import {BLOG_TYPES} from "../constants/constTypes";

const isHiddenOptions = [
    {
        name: 'Ակտիվ',
        id: 'false',
    },
    {
        name: 'Ոչ ակտիվ',
        id: 'true',
    }
];

const blogTypeOptions = Object.keys(BLOG_TYPES).map(key => {
    return {
        id: BLOG_TYPES[key].key,
        name: BLOG_TYPES[key].title,
    }
})
class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            text: '',
            type: undefined,
            isHidden: undefined,
        };
        this.getSearchValue = this.getSearchValue.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.loadMoreItems = this.loadMoreItems.bind(this);
    }

    componentDidMount() {
        const {pageOffset} = this.props
        if (pageOffset.pageName==='dashboard' && pageOffset.offset) {
            setTimeout(()=>{
                window.scrollTo(0, 1000);
            }, 0)
            setPageOffset(null);
        }  else {
              this.props.GetBlogs();
        }

    }

    loadMoreItems() {
        const {blogs} = this.props;
        const {hasMore} = blogs;
        const {type, text, isHidden} = this.state;
        // console.log(name, value)
        const filters = {
            type,
            text,
            isHidden
        };
        hasMore && this.props.GetBlogs({
            reset: false,
            offset: blogs.itemsList.length,
            ...filters,
        });
    };

    getSearchValue(value) {
        if (!value) {
            this.handleChange({name:'text', value})
        } else {
            this.setState({
                'text':value,
            })
        }
    }

    handleChange({name, value} = {}) {
        const {type, text, isHidden} = this.state;

        const newFilter = {
            isHidden,
            type,
            text,
            [name]:value
        };
        name && (newFilter[name] = value !== 'remove' ? value : undefined);

        this.setState({
            ...newFilter,
        });
        if (newFilter?.text?.length === 1) {
            return;
        }
        this.props.GetBlogs(newFilter);
    }

    render() {
        const {text, type, isHidden} = this.state;
        const {blogs, accessPages, isAdmin,} = this.props;

        const haveBlogsAccess = isAdmin || accessPages?.includes(ACCESS_PAGES.blogs?.key);
        const filters = <div className={'product-filters'}>
            <InputGroup inputType="selectCustom"
                        placeholder="Կարգավիճակ"
                        name="isHidden"
                        showSearch={false}
                        value={isHidden}
                        onChange={this.handleChange}
                        options={isHiddenOptions}
                        withClear={'Բոլորը'}>
            </InputGroup>
            <InputGroup inputType="selectCustom"
                        placeholder="Ընտրել տեսակ"
                        name="type"
                        showSearch={false}
                        value={type}
                        onChange={this.handleChange}
                        options={blogTypeOptions}
                        withClear={'Բոլորը'}>
            </InputGroup>
        </div>;
        return <PageWrapper pageTitle={'Բլոգներ'}>
            <section className="dashboard">
                <PageHeader linkTitle={haveBlogsAccess && "Ավելացնել"}
                            addingLink={haveBlogsAccess && "/blogs/add"}
                            getSearchValue={this.getSearchValue}
                            searchItems={this.handleChange}
                            searchValue={text}
                            search={haveBlogsAccess}
                            filters={haveBlogsAccess && filters}>
                </PageHeader>
                <InfiniteScroll
                    hasMore={blogs.hasMore}
                    loadMore={this.loadMoreItems}
                    pageStart={0}
                    className={'blogs'}
                    useWindow={true}
                    initialLoad={false}>
                    {blogs && !!blogs.itemsList.length ? blogs.itemsList.map((item) => {
                        return <BlogCard key={item?.id}
                                            data={item}/>
                    }):
                    <div className={'empty-view'}>
                        <img src={defaultEmptyView}/>
                    </div>}
                </InfiniteScroll>
            </section>
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetBlogs
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
